// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: agent.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AnalysisTreeProto } from "./analysis";
import { AnalysisPlanProto } from "./analysis_plan";
import { CustomAgentProto } from "./custom_agent";
import { AnalysisTreeSessionKey, StateKey } from "./stateful_api";

export const protobufPackage = "com.darwin.agent";

export enum AgentType {
  TISA = 0,
  TIGA = 1,
  TISA_V2 = 2,
  TISA_CONTEXTUALISATION = 3,
  TISA_CHAT = 4,
  PLAN = 5,
  PLAN_STEP_LABEL = 6,
  TISA_SCENARIO = 7,
  TISA_SYNTHESIS = 8,
  TISA_NOTIFICATION = 9,
  UNRECOGNIZED = -1,
}

export function agentTypeFromJSON(object: any): AgentType {
  switch (object) {
    case 0:
    case "TISA":
      return AgentType.TISA;
    case 1:
    case "TIGA":
      return AgentType.TIGA;
    case 2:
    case "TISA_V2":
      return AgentType.TISA_V2;
    case 3:
    case "TISA_CONTEXTUALISATION":
      return AgentType.TISA_CONTEXTUALISATION;
    case 4:
    case "TISA_CHAT":
      return AgentType.TISA_CHAT;
    case 5:
    case "PLAN":
      return AgentType.PLAN;
    case 6:
    case "PLAN_STEP_LABEL":
      return AgentType.PLAN_STEP_LABEL;
    case 7:
    case "TISA_SCENARIO":
      return AgentType.TISA_SCENARIO;
    case 8:
    case "TISA_SYNTHESIS":
      return AgentType.TISA_SYNTHESIS;
    case 9:
    case "TISA_NOTIFICATION":
      return AgentType.TISA_NOTIFICATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AgentType.UNRECOGNIZED;
  }
}

export function agentTypeToJSON(object: AgentType): string {
  switch (object) {
    case AgentType.TISA:
      return "TISA";
    case AgentType.TIGA:
      return "TIGA";
    case AgentType.TISA_V2:
      return "TISA_V2";
    case AgentType.TISA_CONTEXTUALISATION:
      return "TISA_CONTEXTUALISATION";
    case AgentType.TISA_CHAT:
      return "TISA_CHAT";
    case AgentType.PLAN:
      return "PLAN";
    case AgentType.PLAN_STEP_LABEL:
      return "PLAN_STEP_LABEL";
    case AgentType.TISA_SCENARIO:
      return "TISA_SCENARIO";
    case AgentType.TISA_SYNTHESIS:
      return "TISA_SYNTHESIS";
    case AgentType.TISA_NOTIFICATION:
      return "TISA_NOTIFICATION";
    case AgentType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PlanInput {
  /**
   * If possible, provide the complete Analysis plan
   * @Optional if the plan loading takes a while or client
   * can send only the plan_id
   */
  plan?:
    | AnalysisPlanProto
    | undefined;
  /** Either the above field (the complete plan) or the plan ID */
  plan_id?:
    | string
    | undefined;
  /**
   * AnalysisStepProto id for generating step label corresponding to the
   * analysis step
   */
  step_id?: string | undefined;
}

export interface TIGAInput {
  /** Either analysis tree is given or the tree session is given. */
  tree?: AnalysisTreeProto | undefined;
  tree_session?: StateKey | undefined;
}

export interface TISAInput {
  /** Id of the chat to fetch the history from. */
  chat_id?:
    | string
    | undefined;
  /** UserId and metadataId are unique id for the chat. */
  user_id?: string | undefined;
  metadata_id?:
    | string
    | undefined;
  /** Reference to the analysis tree session to be used by TISA. */
  tree_sessions: AnalysisTreeSessionKey[];
  /** Analysis Tree Proto to be used by TISA. */
  trees: AnalysisTreeProto[];
  /** Custom agent for which TISA run is happening for both use cases - synthesis & contextualisation. */
  custom_agent?:
    | CustomAgentProto
    | undefined;
  /**
   * Today's date to be set in system prompt. This is used by EVA for now.
   * If not set, use today's date in the prompt.
   */
  today_date?:
    | string
    | undefined;
  /**
   * Company name to be set in system prompt. This is used by EVA for now.
   * If not set, use the environment variable's value in the prompt.
   */
  company_name?: string | undefined;
}

export interface ChatRequest {
  /** List of user messages to respond to. */
  user_messages: string[];
  stream?:
    | boolean
    | undefined;
  /**
   * @Constraint: One of agent_type or agent_config_id is set.
   * If agent_type is set, then fetch the active agent of that type.
   * If agent_config_id set, then fetch the agent with that config.
   */
  agent_type?: AgentType | undefined;
  agent_config_id?: number | undefined;
  client_tag?:
    | string
    | undefined;
  /**
   * Input for the agent, depending on the agent type.
   * @Constraint: Only one of the following inputs should be set.
   */
  tiga_input?: TIGAInput | undefined;
  tisa_input?: TISAInput | undefined;
  plan_input?: PlanInput | undefined;
}

export interface ClearChatRequest {
  /**
   * Id of the chat to clear. Client must have this ID already since it has
   * fetched the chat history - and wants to clear it.
   */
  chat_id?: string | undefined;
}

function createBasePlanInput(): PlanInput {
  return { plan: undefined, plan_id: undefined, step_id: undefined };
}

export const PlanInput: MessageFns<PlanInput> = {
  encode(message: PlanInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.plan !== undefined) {
      AnalysisPlanProto.encode(message.plan, writer.uint32(10).fork()).join();
    }
    if (message.plan_id !== undefined) {
      writer.uint32(18).string(message.plan_id);
    }
    if (message.step_id !== undefined) {
      writer.uint32(26).string(message.step_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plan = AnalysisPlanProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plan_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.step_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanInput {
    return {
      plan: isSet(object.plan) ? AnalysisPlanProto.fromJSON(object.plan) : undefined,
      plan_id: isSet(object.plan_id) ? globalThis.String(object.plan_id) : undefined,
      step_id: isSet(object.step_id) ? globalThis.String(object.step_id) : undefined,
    };
  },

  toJSON(message: PlanInput): unknown {
    const obj: any = {};
    if (message.plan !== undefined) {
      obj.plan = AnalysisPlanProto.toJSON(message.plan);
    }
    if (message.plan_id !== undefined) {
      obj.plan_id = message.plan_id;
    }
    if (message.step_id !== undefined) {
      obj.step_id = message.step_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanInput>, I>>(base?: I): PlanInput {
    return PlanInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanInput>, I>>(object: I): PlanInput {
    const message = createBasePlanInput();
    message.plan = (object.plan !== undefined && object.plan !== null)
      ? AnalysisPlanProto.fromPartial(object.plan)
      : undefined;
    message.plan_id = object.plan_id ?? undefined;
    message.step_id = object.step_id ?? undefined;
    return message;
  },
};

function createBaseTIGAInput(): TIGAInput {
  return { tree: undefined, tree_session: undefined };
}

export const TIGAInput: MessageFns<TIGAInput> = {
  encode(message: TIGAInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree !== undefined) {
      AnalysisTreeProto.encode(message.tree, writer.uint32(10).fork()).join();
    }
    if (message.tree_session !== undefined) {
      StateKey.encode(message.tree_session, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TIGAInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTIGAInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree = AnalysisTreeProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tree_session = StateKey.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TIGAInput {
    return {
      tree: isSet(object.tree) ? AnalysisTreeProto.fromJSON(object.tree) : undefined,
      tree_session: isSet(object.tree_session) ? StateKey.fromJSON(object.tree_session) : undefined,
    };
  },

  toJSON(message: TIGAInput): unknown {
    const obj: any = {};
    if (message.tree !== undefined) {
      obj.tree = AnalysisTreeProto.toJSON(message.tree);
    }
    if (message.tree_session !== undefined) {
      obj.tree_session = StateKey.toJSON(message.tree_session);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TIGAInput>, I>>(base?: I): TIGAInput {
    return TIGAInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TIGAInput>, I>>(object: I): TIGAInput {
    const message = createBaseTIGAInput();
    message.tree = (object.tree !== undefined && object.tree !== null)
      ? AnalysisTreeProto.fromPartial(object.tree)
      : undefined;
    message.tree_session = (object.tree_session !== undefined && object.tree_session !== null)
      ? StateKey.fromPartial(object.tree_session)
      : undefined;
    return message;
  },
};

function createBaseTISAInput(): TISAInput {
  return {
    chat_id: undefined,
    user_id: undefined,
    metadata_id: undefined,
    tree_sessions: [],
    trees: [],
    custom_agent: undefined,
    today_date: undefined,
    company_name: undefined,
  };
}

export const TISAInput: MessageFns<TISAInput> = {
  encode(message: TISAInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat_id !== undefined) {
      writer.uint32(10).string(message.chat_id);
    }
    if (message.user_id !== undefined) {
      writer.uint32(18).string(message.user_id);
    }
    if (message.metadata_id !== undefined) {
      writer.uint32(26).string(message.metadata_id);
    }
    for (const v of message.tree_sessions) {
      AnalysisTreeSessionKey.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.trees) {
      AnalysisTreeProto.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.custom_agent !== undefined) {
      CustomAgentProto.encode(message.custom_agent, writer.uint32(50).fork()).join();
    }
    if (message.today_date !== undefined) {
      writer.uint32(58).string(message.today_date);
    }
    if (message.company_name !== undefined) {
      writer.uint32(66).string(message.company_name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TISAInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTISAInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metadata_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tree_sessions.push(AnalysisTreeSessionKey.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.trees.push(AnalysisTreeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.custom_agent = CustomAgentProto.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.today_date = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.company_name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TISAInput {
    return {
      chat_id: isSet(object.chat_id) ? globalThis.String(object.chat_id) : undefined,
      user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : undefined,
      metadata_id: isSet(object.metadata_id) ? globalThis.String(object.metadata_id) : undefined,
      tree_sessions: globalThis.Array.isArray(object?.tree_sessions)
        ? object.tree_sessions.map((e: any) => AnalysisTreeSessionKey.fromJSON(e))
        : [],
      trees: globalThis.Array.isArray(object?.trees) ? object.trees.map((e: any) => AnalysisTreeProto.fromJSON(e)) : [],
      custom_agent: isSet(object.custom_agent) ? CustomAgentProto.fromJSON(object.custom_agent) : undefined,
      today_date: isSet(object.today_date) ? globalThis.String(object.today_date) : undefined,
      company_name: isSet(object.company_name) ? globalThis.String(object.company_name) : undefined,
    };
  },

  toJSON(message: TISAInput): unknown {
    const obj: any = {};
    if (message.chat_id !== undefined) {
      obj.chat_id = message.chat_id;
    }
    if (message.user_id !== undefined) {
      obj.user_id = message.user_id;
    }
    if (message.metadata_id !== undefined) {
      obj.metadata_id = message.metadata_id;
    }
    if (message.tree_sessions?.length) {
      obj.tree_sessions = message.tree_sessions.map((e) => AnalysisTreeSessionKey.toJSON(e));
    }
    if (message.trees?.length) {
      obj.trees = message.trees.map((e) => AnalysisTreeProto.toJSON(e));
    }
    if (message.custom_agent !== undefined) {
      obj.custom_agent = CustomAgentProto.toJSON(message.custom_agent);
    }
    if (message.today_date !== undefined) {
      obj.today_date = message.today_date;
    }
    if (message.company_name !== undefined) {
      obj.company_name = message.company_name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TISAInput>, I>>(base?: I): TISAInput {
    return TISAInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TISAInput>, I>>(object: I): TISAInput {
    const message = createBaseTISAInput();
    message.chat_id = object.chat_id ?? undefined;
    message.user_id = object.user_id ?? undefined;
    message.metadata_id = object.metadata_id ?? undefined;
    message.tree_sessions = object.tree_sessions?.map((e) => AnalysisTreeSessionKey.fromPartial(e)) || [];
    message.trees = object.trees?.map((e) => AnalysisTreeProto.fromPartial(e)) || [];
    message.custom_agent = (object.custom_agent !== undefined && object.custom_agent !== null)
      ? CustomAgentProto.fromPartial(object.custom_agent)
      : undefined;
    message.today_date = object.today_date ?? undefined;
    message.company_name = object.company_name ?? undefined;
    return message;
  },
};

function createBaseChatRequest(): ChatRequest {
  return {
    user_messages: [],
    stream: undefined,
    agent_type: undefined,
    agent_config_id: undefined,
    client_tag: undefined,
    tiga_input: undefined,
    tisa_input: undefined,
    plan_input: undefined,
  };
}

export const ChatRequest: MessageFns<ChatRequest> = {
  encode(message: ChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.user_messages) {
      writer.uint32(10).string(v!);
    }
    if (message.stream !== undefined) {
      writer.uint32(16).bool(message.stream);
    }
    if (message.agent_type !== undefined) {
      writer.uint32(24).int32(message.agent_type);
    }
    if (message.agent_config_id !== undefined) {
      writer.uint32(32).int32(message.agent_config_id);
    }
    if (message.client_tag !== undefined) {
      writer.uint32(42).string(message.client_tag);
    }
    if (message.tiga_input !== undefined) {
      TIGAInput.encode(message.tiga_input, writer.uint32(50).fork()).join();
    }
    if (message.tisa_input !== undefined) {
      TISAInput.encode(message.tisa_input, writer.uint32(58).fork()).join();
    }
    if (message.plan_input !== undefined) {
      PlanInput.encode(message.plan_input, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user_messages.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.stream = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.agent_type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.agent_config_id = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.client_tag = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tiga_input = TIGAInput.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tisa_input = TISAInput.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.plan_input = PlanInput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatRequest {
    return {
      user_messages: globalThis.Array.isArray(object?.user_messages)
        ? object.user_messages.map((e: any) => globalThis.String(e))
        : [],
      stream: isSet(object.stream) ? globalThis.Boolean(object.stream) : undefined,
      agent_type: isSet(object.agent_type) ? agentTypeFromJSON(object.agent_type) : undefined,
      agent_config_id: isSet(object.agent_config_id) ? globalThis.Number(object.agent_config_id) : undefined,
      client_tag: isSet(object.client_tag) ? globalThis.String(object.client_tag) : undefined,
      tiga_input: isSet(object.tiga_input) ? TIGAInput.fromJSON(object.tiga_input) : undefined,
      tisa_input: isSet(object.tisa_input) ? TISAInput.fromJSON(object.tisa_input) : undefined,
      plan_input: isSet(object.plan_input) ? PlanInput.fromJSON(object.plan_input) : undefined,
    };
  },

  toJSON(message: ChatRequest): unknown {
    const obj: any = {};
    if (message.user_messages?.length) {
      obj.user_messages = message.user_messages;
    }
    if (message.stream !== undefined) {
      obj.stream = message.stream;
    }
    if (message.agent_type !== undefined) {
      obj.agent_type = agentTypeToJSON(message.agent_type);
    }
    if (message.agent_config_id !== undefined) {
      obj.agent_config_id = Math.round(message.agent_config_id);
    }
    if (message.client_tag !== undefined) {
      obj.client_tag = message.client_tag;
    }
    if (message.tiga_input !== undefined) {
      obj.tiga_input = TIGAInput.toJSON(message.tiga_input);
    }
    if (message.tisa_input !== undefined) {
      obj.tisa_input = TISAInput.toJSON(message.tisa_input);
    }
    if (message.plan_input !== undefined) {
      obj.plan_input = PlanInput.toJSON(message.plan_input);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatRequest>, I>>(base?: I): ChatRequest {
    return ChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatRequest>, I>>(object: I): ChatRequest {
    const message = createBaseChatRequest();
    message.user_messages = object.user_messages?.map((e) => e) || [];
    message.stream = object.stream ?? undefined;
    message.agent_type = object.agent_type ?? undefined;
    message.agent_config_id = object.agent_config_id ?? undefined;
    message.client_tag = object.client_tag ?? undefined;
    message.tiga_input = (object.tiga_input !== undefined && object.tiga_input !== null)
      ? TIGAInput.fromPartial(object.tiga_input)
      : undefined;
    message.tisa_input = (object.tisa_input !== undefined && object.tisa_input !== null)
      ? TISAInput.fromPartial(object.tisa_input)
      : undefined;
    message.plan_input = (object.plan_input !== undefined && object.plan_input !== null)
      ? PlanInput.fromPartial(object.plan_input)
      : undefined;
    return message;
  },
};

function createBaseClearChatRequest(): ClearChatRequest {
  return { chat_id: undefined };
}

export const ClearChatRequest: MessageFns<ClearChatRequest> = {
  encode(message: ClearChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat_id !== undefined) {
      writer.uint32(10).string(message.chat_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClearChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClearChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClearChatRequest {
    return { chat_id: isSet(object.chat_id) ? globalThis.String(object.chat_id) : undefined };
  },

  toJSON(message: ClearChatRequest): unknown {
    const obj: any = {};
    if (message.chat_id !== undefined) {
      obj.chat_id = message.chat_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClearChatRequest>, I>>(base?: I): ClearChatRequest {
    return ClearChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClearChatRequest>, I>>(object: I): ClearChatRequest {
    const message = createBaseClearChatRequest();
    message.chat_id = object.chat_id ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
